type HeroContext = {
  durationMinutes: number;
  streakDays: number;
  tunes: number;
};

type HeroCopyTemplate = (ctx: HeroContext) => string;

const TEMPLATES: HeroCopyTemplate[] = [
  ({ durationMinutes, tunes }) =>
    `Nice ${durationMinutes}-minute session — ${tunes} tune${tunes === 1 ? '' : 's'} touched.`,
  ({ streakDays }) =>
    `Keep it going — that's ${streakDays} day${streakDays === 1 ? '' : 's'} in a row.`,
  ({ tunes, durationMinutes }) =>
    `${tunes} tune${tunes === 1 ? '' : 's'}, ${durationMinutes} minutes. Solid work.`,
  ({ durationMinutes }) =>
    `${durationMinutes} minutes well spent. Every session counts.`,
  ({ streakDays, tunes }) =>
    `${streakDays}-day streak and ${tunes} tune${tunes === 1 ? '' : 's'} practiced. Keep the momentum.`,
  ({ durationMinutes, tunes }) =>
    `${tunes} tune${tunes === 1 ? '' : 's'} in ${durationMinutes} minutes. Great focus today.`,
];

export function pickHeroCopy(ctx: HeroContext, seed: number): string {
  const index = Math.abs(seed) % TEMPLATES.length;
  const template = TEMPLATES[index];
  if (!template) return TEMPLATES[0]!(ctx);
  return template(ctx);
}

function seedFromString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash;
}

export function heroCopyForSession(sessionId: string, ctx: HeroContext): string {
  const seed = seedFromString(sessionId);
  return pickHeroCopy(ctx, seed);
}
